exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.styles--onlyXs__2JhHw{display:none !important}}@media (min-width: 768px){.styles--smUp__21iAX{display:none !important}}@media (max-width: 999px){.styles--mdDown__5w8_c{display:none !important}}.styles--courseChecked__3cOre{-webkit-box-flex:0;-ms-flex:0 0 56px;flex:0 0 56px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:56px;height:56px}.styles--name__33aM-{display:block;display:-webkit-box;line-clamp:2;text-overflow:-o-ellipsis-lastline;text-overflow:ellipsis;overflow:hidden;-webkit-line-clamp:2;-webkit-box-orient:vertical;max-height:3.3em;line-height:1.65em;word-break:break-word}\n", ""]);

// exports
exports.locals = {
	"onlyXs": "styles--onlyXs__2JhHw",
	"smUp": "styles--smUp__21iAX",
	"mdDown": "styles--mdDown__5w8_c",
	"courseChecked": "styles--courseChecked__3cOre",
	"name": "styles--name__33aM-"
};